<template>
    <div class="vehicleCertification flex-column">
        <div style="background-color: #fff">
            <div class="certificate-image-wrap">
                <van-uploader :disabled="verifyStatus != 1" :before-read="beforeRead" :after-read="afterReadFront">
                    <template #default>
                        <div v-if="loading1" class="loading">
                            <van-loading color="#fff" text-color="#fff" vertical>图片上传中</van-loading>
                        </div>
                        <img v-if="!loading1 && carItem.driveImg" :src="carItem.driveImg" alt="" />
                        <img v-else-if="!loading1 && !carItem.driveImg" :src="fronImage" alt="" />
                    </template>
                </van-uploader>
            </div>
            <div class="certificate-image-wrap">
                <van-uploader :disabled="verifyStatus != 1" :before-read="beforeRead" :after-read="afterReadBack">
                    <template #default>
                        <div v-if="loading2" class="loading">
                            <van-loading color="#fff" text-color="#fff" vertical>图片上传中</van-loading>
                        </div>
                        <img v-if="!loading2 && carItem.carProspectImg" :src="carItem.carProspectImg" alt="" />
                        <img v-else-if="!loading2 && !carItem.carProspectImg" :src="backImage" alt="" />
                    </template>
                </van-uploader>
            </div>
            <div class="vehicleCertification-warning">
                <div class="warning-header flex align-center">
                    <img src="@/assets/images/mycar/warning.png" alt="" />
                    <p>温馨小提示:</p>
                </div>
                <div class="vehicleCertification-warning-content">
                    <span>·行驶证仅供证明使用，不会公开给任何组织和个人；</span><br />
                    <span>·车辆认证才能查看具体停车场，否则部分已***代替；</span><br />
                    <span>·审核不可以修改；</span><br />
                    <span>·人工审核，需要一个工作日；</span><br />
                    <span>·如需帮助请拨打 {{ zzconfig.PHONE }}。</span><br />
                </div>
            </div>
        </div>
        <!-- 未认证 和 认证未通过 显示 -->
        <div class="vehicleCertification-confirm" v-if="verifyStatus == 1">
            <van-checkbox checked-color="#009af3" v-model="checked">我已同意<span @click.stop="toArgeement" style="color: #009af3; text-decoration: underline">《认证协议》</span></van-checkbox>
            <van-button @click="handleVerify" class="vehicleCertification-confirm-btn" block>马上认证</van-button>
        </div>
        <!-- 认证不通过 重新认证 -->
        <van-field style="margin-top: 10px" type="textarea" v-if="verifyStatus == 4" v-model="carItem.reason" label="未通过原因" disabled />
        <div class="vehicleCertification-confirm" v-if="verifyStatus == 4">
            <p class="vehicleCertification-confirm-fail">审核不通过，请重新上传</p>

            <van-button @click="handleReVerify" class="vehicleCertification-confirm-btn" plain block>重新认证</van-button>
        </div>

        <div class="vehicleCertification-verifyStatus" v-if="verifyStatus != 1">
            <img :src="verifyImage" alt="" />
        </div>
    </div>
</template>

<script>
import { uploadImage, certPlateNum } from "@/api/api";
import { beforeRead } from "@/libs/tools";
import { zzconfig } from "@/config/zzconfig";
export default {
    name: "VehicleCertification",
    components: {},
    data() {
        return {
            zzconfig,
            checked: false,
            fronImage: require("@/assets/images/mycar/certificate-front.png"),
            backImage: require("@/assets/images/mycar/certificate-back.png"),
            verifyStatus: -2, //  -1:不通过 0:未认证 1:成功 2:认证中

            //4 不通过  1 未认证 2 审核中 3已认证

            carItem: {
                driveImg: "",
                carProspectImg: "",
            },
            loading1: false,
            loading2: false,
        };
    },
    computed: {
        verifyImage() {
            let imagePath = this.verifyStatus == 2 ? require("@/assets/images/mycar/auditIng.png") : this.verifyStatus == 3 ? require("@/assets/images/mycar/auditPass.png") : this.verifyStatus == 4 ? require("@/assets/images/mycar/auditFail.png") : "";
            return imagePath;
        },
    },

    mounted() {
        let carItem = this.$route.params;
        this.carItem = { ...this.carItem, ...carItem };
        this.verifyStatus = this.carItem.certStatus;
    },
    methods: {
        beforeRead,
        //跳转到用户协议
        toArgeement() {
            this.$router.push({ name: "verifyProtocol", params: this.carItem });
        },
        //上传函数
        handleVerify() {
            if (!this.checked) {
                this.$toast("请先查看认证协议");
            } else {
                if (!this.carItem.driveImg || !this.carItem.carProspectImg) {
                    this.$toast("请上传两张图片");
                    return;
                }
                let obj = {
                    plateNum: this.carItem.plateNum,
                    driverFrontUrl: this.carItem.driveImg,
                    driverBackUrl: this.carItem.carProspectImg,
                };
                certPlateNum(obj).then((res) => {
                    if (res.code == 200) {
                        this.$toast("添加认证成功");
                        this.$router.back();
                    }
                });
            }
        },
        //重新认证
        handleReVerify() {
            this.carItem.certStatus = 1;
            this.carItem.driveImg = "";
            this.carItem.carProspectImg = "";
            this.verifyStatus = 1;
        },

        //上传第一张照片
        afterReadFront(file) {
            this.loading1 = true;
            uploadImage(file.file).then((res) => {
                if (res.code == 200) {
                    this.loading1 = false;
                    this.carItem.driveImg = res.data.imgUrl;
                }
            });
        },
        //上传第二张照片
        afterReadBack(file) {
            this.loading2 = true;
            uploadImage(file.file).then((res) => {
                if (res.code == 200) {
                    this.loading2 = false;
                    this.carItem.carProspectImg = res.data.imgUrl;
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .van-uploader__preview-image {
    width: 100%;
    height: 100%;
}
.loading {
    background-color: #4a4a4b;
    width: 561px;
    height: 358px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
}
.vehicleCertification {
    min-height: 100vh;

    .certificate-image-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 561px;
        height: 358px;
        margin: 10px auto;
        border: 1px dotted #999999;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
        }
    }

    .vehicleCertification-warning {
        padding: 32px;

        .warning-header {
            img {
                width: 24px;
                height: 32px;
            }

            p {
                font-size: 30px;
                color: #212121;
                margin-left: 17px;
            }
        }

        .vehicleCertification-warning-content {
            font-size: 28px;
            color: #999999;
            margin-top: 23px;
        }
    }

    .vehicleCertification-confirm {
        padding: 24px;
        margin-top: auto;

        .vehicleCertification-confirm-btn {
            width: 702px;
            height: 70px;
            font-size: 32px;
            margin-top: 32px;
            border-radius: 16px;
            color: #fff;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        }
        .vehicleCertification-confirm-fail {
            font-size: 24px;
            color: #f72d2d;
            text-align: center;
            margin-top: 15px;
        }
    }
    .vehicleCertification-verifyStatus {
        width: 191px;
        height: 165px;
        position: fixed;
        top: 295px;
        right: 14px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
